<template>
    <div>
        <modal v-if="showModal" :type="modalType" :data="selectedActivity" @close="closeModal" />
        <div v-if="!activities || activities.length === 0" class="cell large-3">
            <p><em>Der er ingen aktiviteter tilknyttet opgaven</em></p>
        </div>
        <div class="grid-x accordion-counter align-items">
            <div class="cell flexbox-end">
                <button v-if="activities && activities.length > 0" class="button-blue" :disabled="!checkValidStatus || !isAccordionSelected" @click="setActivityStatus()">
                    <icon class="envelope-svg small-svg" name="envelope" />
                    Rekvirer
                </button>
                <button v-if="activities && activities.length > 0" class="button-blue" @click="removeActivity()" :disabled="!isAccordionSelected">
                    <icon class="bin-svg small-svg fill-dark-gray" name="bin" />
                    Slet
                </button>
                <button v-if="activities && activities.length > 0" class="button-blue" style="margin-right: 0px;" @click="openModal('task-modal-routine')" :disabled="!isAccordionSelected  || (isAccordionSelected && allowRoutine)">
                    <icon class="routine-svg small-svg fill-dark-gray" name="loop" />
                    Opret rutine
                </button>
            </div>
        </div>
        <!-- ------------- Header ------------- -->
        <transition-group name="list" v-if="activities && activities.length > 0">
            <div class="accordion-item" v-for="(activity, index) in filteredListActivities" :key="`activity-${activity.activityId}`">
                <div class="grid-x align-items flexbox-nowrap">
                    <div class="cell auto accordion-container">
                        <transition name="fade">
                            <div class="object-counter" :key="`activities-${activity.activityId}`" :title="activity.allObjectsInActivityCount > 0 ? 'Antal objekter tilknyttet' : 'Ingen objekter tilknyttet'" >{{ activity.allObjectsInActivityCount ? activity.allObjectsInActivityCount : 0 }}</div>
                        </transition>
                        <div class="grid-x accordion row align-items" @click="select(activity)" :class="{'selected': activity.selected}">
                            <div class="cell icon-cell accordion-toggle flexbox-center" @click="activity.isAccordionOpen = !activity.isAccordionOpen">
                                <icon class="large-svg fill-dark-gray" :class="{'rotated-accordion': activity.isAccordionOpen}" name="chevron-right" style="transition: all 0.3s;" />
                            </div>
                            <div class="cell large-2 item" style="margin-right: 5px;">
                                <span class="activity-name">{{activity.activityType}}</span>
                            </div>
                            <div v-if="activity.sentToUser" class="cell activity-user item truncate-fade">
                                <span>{{activity.sentToUser}}</span>
                                <span>{{activity.sentToOrganization}}</span>
                            </div>
                            <div v-else class="cell activity-user item truncate-fade flexbox-align-items">
                                <span>Ingen entreprenør</span>
                            </div>
                            <div class="cell item flexbox activity-date">
                                <div class="doubleRowIcon">
                                    <icon v-show="activity.routineIntervalTypeId" class="small-svg fill-dark-gray" name="loop" />
                                    <icon v-show="!activity.routineIntervalTypeId" class="small-svg fill-dark-gray" name="calendar" />
                                </div>
                                <div>
                                    <span v-if="activity.startDate && activity.latestDate" style="display: inline-block">Start: {{ activity.startDate | formatDateShort }} <br/>Slut: {{ activity.latestDate | formatDateShort }}</span>
                                    <span v-else-if="activity.startDate" style="display: inline-block">Start: {{ activity.startDate | formatDateShort }}</span>
                                    <span v-else-if="activity.latestDate" style="display: inline-block">Slut: {{ activity.latestDate | formatDateShort }}</span>
                                    <span v-else style="display: inline-block">Ingen dato</span>
                                    <span v-if="activity.routineIntervalTypeId">Hver<template v-if="getHumanTime(activity.routineUnitOfTimeTypeId) === 'år'">t</template> {{activity.routineInterval}}. {{getHumanTime(activity.routineUnitOfTimeTypeId)}}</span>
                                </div>
                            </div>
                            <div class="cell large-1 item flexbox-center" :title="(activity.description ? 'Bemærkning: ' + activity.description + '\n' : '') + (activity.reference ? 'Reference: ' + activity.reference : '')">
                                <icon v-if="activity.reference" class="dollar-svg small-svg fill-dark-gray" name="dollar"/>
                                <icon v-if="activity.description" class="bubble-svg small-svg fill-dark-gray" name="bubble" />
                            </div>
                            <div class="cell item flexbox-start activity-status-container" v-if="$route.name === 'task' || $route.name === 'taskid'">
                                <div class="activity-status" :class="backgroundColor(activity.status, activity)">
                                    <template v-if="activity.declined">Accepteret</template>
                                    <template v-else-if="activity.routineIntervalTypeId">Rutine</template>
                                    <template v-else-if="activity.status && activity.status === 'Ny'">Rekvireret</template>
                                    <template v-else-if="activity.activityId && !activity.routineIntervalTypeId && !activity.reportApproveDate && activity.status">{{activity.status}}</template>
                                    <template v-else-if="activity.reportApproveDate">Godkendt</template>
                                    <template v-else-if="activity.reportReadyForApproval && !activity.reportApproveDate">Færdigmeldt</template>
                                    <template v-else-if="activity.requisitionStatus && activity.requisitionStatus !== '' && activity.reportApproveDate === null && !activity.routineIntervalTypeId">{{activity.requisitionStatus}}</template>
                                    <template v-else>Ikke rekvireret</template>
                                </div>
                            </div>
                            <div class="cell auto flexbox-end">
                                <a class="flexbox-center accordion-edit" title="Rediger rutine" v-if="activity.routineIntervalTypeId" @click="openModal('task-modal-routine', activity)">
                                    <icon class="medium-svg fill-dark-gray" name="loop" />
                                </a>
                                <a class="flexbox-center accordion-edit" title="Rediger aktivitet" @click="openModal('task-modal-activity', activity)" >
                                    <icon class="medium-svg fill-dark-gray" name="pencil" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid-x">
                    <div class="cell accordion customContentInsertion" v-if="activity.isAccordionOpen">
                        <div v-if="activity.status !== 'Ikke rekvireret'" class="requisition-serialNumber">Løbenummer: <strong>{{ activity.requisitionSerialNumber }}</strong></div>

                        <div v-if="activity.highlight" class="filters flexbox-center">
                            <span>Filter: {{ selectedObjects.length }} af {{ objectListLength(activity.objectList) }} objekter </span>
                            <div class="filtersClose" @click="resetHighlightSelection">
                                <icon class="small-svg fill-selected-dark-gray" name="cancel" />
                            </div>
                        </div>
                        <transition-group name="text-fade" mode="out-in" :css="activity.highlight === true" v-if="(objectListLength(activity.objectList ? activity.objectList : false))">
                            <div class="grid-x" v-for="(object, indexed) in getObjects(activity,index)" :key="`objects-${object.keyValue}${indexed}`">
                                <div class="cell large-11">
                                    <div class="grid-x content object-row" :class="{'object-clickable': object.geomWkt}" @click="highlightObject(object)">
                                        <div class="cell flexbox-center icon-cell" style="width: 30px; justify-content: left;">
                                            <icon v-if="object.geomWkt" class="small-svg fill-dark-gray" name="location" />
                                            <icon v-else class="small-svg fill-dark-gray" name="asset" />
                                        </div>
                                            <div class="cell large-11">
                                                <span v-if="object && !object.name && !object.LayerName && !object.layerName && !object.keyValue"><em>Intet navn eller id på objekt</em></span>
                                                <span :key="`object-${object.name}` + index" :class="{highlightedObject:activity.highlight}">
                                                    <span class="object-name" v-if="object && object.LayerName">{{ object.LayerName }}</span>
                                                    <span class="object-name" v-if="object && object.layerName && !object.LayerName">{{ object.layerName }}</span>
                                                    <span class="object-name" v-if="(object && object.LayerName && object.name) || object && object.layerName && object.name"> - </span>
                                                    <span class="object-name" v-if="object && object.name">{{object.name}}</span>
                                                    <span class="object-description" v-if="object && object.objectDescription && object.objectDescription !== '[]'" v-html="formatDescription(object)"></span>
                                                </span>
                                        </div>
                                    </div>
                                </div>
                                <button class="flexbox-center delete-object" v-if="showHideRemove(activity)" @click="deleteObjectHandling(activity.activityId, object.objectId)">
                                    <icon class="bin-svg small-svg fill-dark-gray" name="bin" />
                                </button>
                            </div>
                            <span class="page-information" :key="`viser-${activity}`" v-if="!activity.highlight && objectListLength(activity.objectList) !== 0">Viser {{ objectListLength(activity.objectList) }} af {{activity.allObjectsInActivityCount}} objekter<br />&nbsp;</span>
                        </transition-group>
                        <div v-if="activity.allObjectsInActivityCount === 0 || (activity.objectList ? activity.objectList.length === 0 && activity.allObjectsInActivityCount === 0 : false)" class="grid-x content">
                            <span><em>Der er ingen objekter tilknyttet til denne aktivitet.</em></span>
                        </div>
                        <div v-else-if="(methodObjectLength(activity.objectList) && activity.allObjectsInActivityCount > 0) && (activities.objectList ? activities.objectList.length <= 0 : true)" class="grid-x content">
                            <span><em>Zoom ind eller flyt på kortet for at vise tilknyttet objekter til denne aktivitet.</em></span>
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>

        <button class="new-accordion" @click="openModal('task-modal-activity')" >Tilføj aktivitet</button>
        <button class="new-accordion" :disabled="!getActiveTaskId" @click="openModal('task-modal-activity-template')">Tilføj aktiviteter fra skabelon</button>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import modal from './../../shared/modal/modal.vue'

export default {
    props: {
        onObjectChange: {
            type: Function
        },
        selectedObjects: [],
        resetSelection: {
            type: Function
        },
        zoomLimit: false,
        deleteObject: {
            type: Function
        },
        setActivityStatus: {
            type: Function
        },
        closedActivities: false
    },
    components: {
        modal
    },
    data () {
        return {
            showModal: false,
            modalType: null,
            selectedActivity: '',
            isAccordionSelected: false,
            higlightedObject: {},
            allowRoutine: false,
            doRecalculateFilteredList: false,
            objectsHighlighted: null
        }
    },
    computed: {
        ...mapGetters({
            activities: 'activitiesAndObjectsList',
            getActiveTaskId: 'getActiveTaskId',
            selectedActivities: 'getSelectedActivities',
            unitOfTimeTypeList: 'getSysUnitOfTimeTypeList',
            task: 'getSelectedTask',
            applicationSettings: 'getApplicationSettings',
            selectedSupplyType: 'selectedSupplyType'
        }),

        filteredListActivities () {
            // Workaround: doRecalculateFilteredList tvinger liste til at blive genberegnet
            if (this.doRecalculateFilteredList === true || this.doRecalculateFilteredList === false) {
                if (!this.closedActivities) {
                    return this.sortActivities([...this.activities].filter(l => !l.reportApproveDate))
                } else {
                    return this.sortActivities([...this.activities])
                }
            }
        },
        checkValidStatus () {
            let hide = this.selectedActivities.filter(p => p.selected && (p.status === 'Ikke rekvireret' || p.status === 'Kaldt tilbage')).length > 0
            return hide
        }
    },
    watch: {
        activities: {
            handler (value) {
                this.doRecalculateFilteredList = false
                this.doRecalculateFilteredList = true
            }
        },
        templates: {
            handler (value) {
                this.doRecalculateFilteredList = false
                this.doRecalculateFilteredList = true
            }
        },
        selectedObjects (objects) {
            if (objects.length > 0) {
                // Find the highlighted object in all activities
                objects.forEach(object => {
                    this.activities.forEach((activity) => {
                        const objects = activity.objectList.some(o => o.keyValue === object.feature.cargo.keyValue)
                        if (objects) {
                            activity.highlight = true
                            activity.highlightedObjects = [object.feature.cargo]
                            activity.isAccordionOpen = false
                            activity.isAccordionOpen = true
                        }
                    })
                })
            }
        }
    },
    methods: {
        ...mapActions({
            setSelectedActivities: 'setSelectedActivities',
            deleteActivities: 'deleteActivities'
        }),
        backgroundColor (status, activity) {
            if (activity.routineIntervalTypeId) {
                return 'blue-status'
            }
            if (activity.reportApproveDate) {
                return 'purple-status'
            }
            if (activity.reportReadyForApproval) {
                return 'green-status'
            }
            if (activity.requisitionStatus && activity.requisitionStatus !== '' && activity.reportApproveDate === null) {
                if (activity.requisitionStatus.toLowerCase() === 'accepteret') {
                    return 'blue-status'
                }
                if (activity.requisitionStatus.toLowerCase() === 'rekvireret' || activity.requisitionStatus.toLowerCase() === 'ny') {
                    return 'orange-status'
                }
                if (activity.requisitionStatus.toLowerCase() === 'kaldt tilbage') {
                    return 'brown-status'
                }
            }

            if (status) {
                if (status.toLowerCase() === 'rutine') {
                    return 'blue-status'
                }
                if (status.toLowerCase() === 'ikke rekvireret') {
                    return 'gray-status'
                }
                if (status.toLowerCase() === 'accepteret') {
                    return 'blue-status'
                }
                if (status.toLowerCase() === 'godkendt') {
                    return 'purple-status'
                }
                if (status.toLowerCase() === 'færdigmeldt') {
                    return 'green-status'
                }
                if (status.toLowerCase() === 'rekvireret') {
                    return 'orange-status'
                }
                if (status.toLowerCase() === 'kaldt tilbage') {
                    return 'brown-status'
                }
            }

            return 'gray-status'
        },
        getObjects (activity) {
            if (activity.highlight) {
                return activity.highlightedObjects
            } else if (activity.objectList) {
                return activity.objectList
            }
        },
        showHideRemove (activity) {
            let visible = true
            if (activity.routineIntervalTypeId) {
                if (activity.objectList.length === 1) {
                    visible = false
                }
            }
            return visible
        },
        methodObjectLength (objectList) {
            if (objectList === null) {
                return true
            }
            if (objectList && objectList.length > 0) {
                let filt = objectList.filter(o => !o.deleting).length === 0
                return filt
            } else {
                return true
            }
        },
        objectListLength (objectlist) {
            if (!objectlist) {
                return 0
            }
            if (objectlist && objectlist.length > 0) {
                return objectlist.filter(o => !o.deleting).length
            }
            return 0
        },
        deleteObjectHandling (activity, object) {
            this.resetHighlightSelection()
            this.deleteObject(activity, object)
        },
        existingObjects (activity) {
            let visibleObjects = 0
            if (activity.objectList) {
                activity.objectList.forEach(object => {
                    if (!object.deleting) {
                        visibleObjects++
                    }
                })
            }
            return visibleObjects
        },
        getHumanTime (unitOfTimeTypeId) {
            let unitOfTime = this.unitOfTimeTypeList.filter(unit => unit.sysUnitOfTimeTypeId === unitOfTimeTypeId)[0]
            if (unitOfTime) {
                return unitOfTime.description.toLowerCase()
            }
            // return this.unitOfTimeTypeList.filter(unit => unit.sysUnitOfTimeTypeId === unitOfTimeTypeId)[0].description.toLowerCase()
        },
        select (activity) {
            activity.selected = !activity.selected
            this.isAccordionSelected = false
            if (!activity.selected) {
                const found = this.selectedActivities.find(a => a.selected)
                if (found) {
                    this.isAccordionSelected = true
                }
            } else {
                this.isAccordionSelected = true
            }

            this.setSelectedActivities(activity).then(() => {
                for (let i in this.selectedActivities) {
                    if (this.selectedActivities[i].selected && !this.selectedActivities[i].routineIntervalTypeId) {
                        this.allowRoutine = false
                        break
                    } else {
                        this.allowRoutine = true
                    }
                }
                if (!this.isAccordionSelected) {
                    this.onObjectChange()
                } else if (this.onObjectChange) {
                    this.onObjectChange(this.selectedActivities)
                }
            })
        },
        openModal (type, data) {
            if (type === 'task-modal-activity' || type === 'task-modal-routine' || this.selectedActivities !== false) {
                let show = true
                let noObjects = []
                for (let i = 0; i < this.selectedActivities.length; i++) {
                    if (this.selectedActivities[i].selected) {
                        if (this.selectedActivities[i].objectList && this.selectedActivities[i].objectList.length > 0) {
                            if (this.selectedActivities[i].objectList.filter(object => object.deleting).length === this.selectedActivities[i].objectList.length) {
                                noObjects.push(this.selectedActivities[i])
                            }
                        } else {
                            noObjects.push(this.selectedActivities[i])
                        }
                    }
                }
                if (!data) {
                    let selectedActivities = this.selectedActivities.filter(activity => activity.selected)
                    if (type === 'task-modal-routine') {
                        if (noObjects.length > 0) {
                            this.$notify({group: 'info', type: 'warn', title: '', text: 'Aktiviteter uden objekter kan ikke laves til rutiner'})
                            if (noObjects.length === selectedActivities.length) {
                                show = false
                            }
                        } else {
                            // SKAL FIXES - HVORFOR DETTE KODE?
                            // this.isAccordionSelected = false
                        }
                    }
                }
                if (show) {
                    this.showModal = true
                    this.modalType = type
                    this.selectedActivity = data
                }
            }
        },
        closeModal () {
            this.showModal = false
            // ---------------- Workaround - start ------------------
            this.doRecalculateFilteredList = true
            this.doRecalculateFilteredList = false
            // ---------------- Workaround - slut ------------------
        },
        removeActivity () {
            // TODO: Needs to be done with new JS syntax..
            let activitiesToDelete = []
            for (let i = 0; i < this.selectedActivities.length; i++) {
                if (this.selectedActivities[i].selected) {
                    if (this.selectedActivities[i].requisitionStatus === 'Ikke rekvireret' || this.selectedActivities[i].requisitionStatus === 'Kaldt tilbage' || this.selectedActivities[i].requisitionStatus === null || this.selectedActivities[i].requisitionStatus === undefined) {
                        if (this.selectedActivities[i].activityId) {
                            activitiesToDelete.push(this.selectedActivities[i].activityId)
                        }
                    } else {
                        this.$notify({group: 'info', type: 'warn', title: '', text: 'Kan ikke slette en aktivitet, som allerede er rekvireret'})
                    }
                }
            }
            if (activitiesToDelete.length > 0) {
                const payload = {
                    'taskId': this.task.taskId,
                    'activityIdList': activitiesToDelete
                }
                this.deleteActivities(payload).then(() => {
                    this.isAccordionSelected = false
                }).then(response => {
                    this.onObjectChange(this.selectedActivities)
                })
            }
        },
        resetHighlightSelection () {
            this.activities.forEach(act => {
                if (act.highlightedObjects && act.highlight) {
                    act.highlightedObjects = []
                    act.highlight = false
                }
            })
            this.resetSelection()
        },
        highlightObject (object) {
            if (object.geomWkt) {
                this.onObjectChange(null, object)
                this.higlightedObject = object
            }
        },
        formatDescription (object) {
            if (object.layerName) {
                const mapService = this.applicationSettings.kortinfoSettings[this.selectedSupplyType.code].mapServiceList.find((service) => {
                    return (service.type === 'ogc' || service.type === 'arcgis' || service.type === 'kortinfo' || service.type === 'ogckortinfo') && service.layers.find(layer => layer.name === object.layerName || layer.name === object.LayerName)
                })

                if (mapService && mapService.layers) {
                    const layer = mapService.layers.find(layer => layer.name === object.layerName || layer.name === object.LayerName)

                    if (layer && layer.displayObjectProperties) {
                        const displayObjectProperties = layer.displayObjectProperties
                        let formatted = ''

                        if (displayObjectProperties) {
                            formatted += '('
                        }
                        try {
                            JSON.parse(object.objectDescription).forEach((object, index) => {
                                if (displayObjectProperties && object && object.Name && object.Value) {
                                    if (index > 0 && formatted !== '(') {
                                        formatted += ', '
                                    }
                                    if (displayObjectProperties.find(property => property.name === object.Name) && displayObjectProperties.find(property => property.name === object.Name).displayText) {
                                        formatted += '<span class="object-description__label">' + displayObjectProperties.find(property => property.name === object.Name).displayText + ':</span>'
                                    } else {
                                        formatted += '<span class="object-description__label">' + object.Name + ':</span>'
                                    }
                                    formatted += ' <span class="object-description__value">' + object.Value + '</span>'
                                }
                            })

                            if (object.objectLength) {
                                if (displayObjectProperties) {
                                    formatted += ', '
                                }
                                formatted += '<span class="object-description__label">Længde:</span>'
                                formatted += ' <span class="object-description__value">' + object.objectLength + '</span>'
                            }
                        } catch (error) {
                            console.error('Format object description', error, object.objectDescription)
                            formatted += object.objectDescription
                        }
                        if (displayObjectProperties) {
                            formatted += ')'
                        }

                        return formatted
                    }
                }
            }

            return '<span class="object-description__label">' + object.objectDescription + '</span>'
        },

        sortActivities (list) {
            // Sort list first by `orderTask`, `startDate` or `latestDate` in that priority
            return list.sort((a, b) => {
                if (a.orderTask !== null && b.orderTask !== null) {
                    return b.orderTask - a.orderTask
                } else if (a.startDate === null && a.latestDate && b.startDate) {
                    const aLatestDate = new Date(a.latestDate)
                    const bStartDate = new Date(b.startDate)

                    return aLatestDate - bStartDate
                } else if (a.latestDate === null && a.startDate && b.latestDate) {
                    const aStartDate = new Date(a.startDate)
                    const bLatestDate = new Date(b.latestDate)

                    return aStartDate - bLatestDate
                } else if (a.latestDate && b.latestDate) {
                    const aLatestDate = new Date(a.latestDate)
                    const bLatestDate = new Date(b.latestDate)

                    return aLatestDate - bLatestDate
                } else if (a.startDate && b.startDate) {
                    const aStartDate = new Date(a.startDate)
                    const bStartDate = new Date(b.startDate)

                    return aStartDate - bStartDate
                } else {
                    return -1
                }
            }).reverse()
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/task/task-accordion-activities.vue